document.addEventListener("DOMContentLoaded", function () {

  function initLifecycle(container) {
    const comingSoon = container.dataset.comingSoon;
    if (!comingSoon) return;

    const comingDate = new Date(comingSoon);
    const timer = container.querySelector(".lifecycle-timer");

    function update() {
      const now = new Date();

      if (now < comingDate) {
        const diff = comingDate - now;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        timer.textContent = `Live in: ${days}d ${hours}h ${minutes}m ${seconds}s`;
        timer.style.display = "block";
      } else {
        timer.style.display = "none";
      }
    }

    update();
    setInterval(update, 1000);
  }

  document.querySelectorAll(".product-lifecycle").forEach(function(container) {
    initLifecycle(container);
  });

});